import { Cookies } from 'react-cookie';

import DeviceWarehouseRespons from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getDevicesInWarehouse = async (isAll: boolean) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('warehouse_traps', {
    headers: {
      Authorization: token,
    },
    params: {
      isAll,
    },
  });
  return data.data as DeviceWarehouseRespons;
};
